import { useLayoutEffect, useMemo, useState } from "react";
import { ChatSupportContext, ChatSupportContextType } from "../../context/chat-support/chat-support.context";
import { ChatContextFilter, ChatSummary } from "../../types/chat-support/chat-support.type";
import { ChatSupportService } from "../../services/chat-support/chat-support.service";
import { ChatSupportRepository } from "../../repositories/chat-support.repository";
import { useRepoistoryFilter } from "../../customHooks/useRepoistoryFilter";
import { ChatNav } from "../../components/chat-support/organisms/chat-nav";
import { ActiveChat } from "../../components/chat-support/organisms/active-chat";

export const ChatSupportPage = () => {
  const [chats, setChats] = useState<ChatSummary[]>([]);
  const [activeChatRoom, setActiveChatRoom] = useState<ChatSummary>(null as unknown as ChatSummary);
  const [isfetching, setIsFetching] = useState(true);
  const { filter, updateFilter } = useRepoistoryFilter<ChatContextFilter>({
    limit: 40,
    orderBy: ["updatedAt", "desc"],
    status: "All",
  });
  const chatSupportService = useMemo(() => new ChatSupportService(new ChatSupportRepository()), []);

  const contextState: ChatSupportContextType["states"] = useMemo(
    () => ({
      chats: {
        chats,
        setChats,
        isfetching,
        setIsFetching,
      },
      activeChatRoom: {
        activeChatRoom,
        setActiveChatRoom,
      },
      filter: { filter, updateFilter },
    }),
    [chats, isfetching, activeChatRoom, filter, updateFilter]
  );

  useLayoutEffect(() => {
    chatSupportService.bindContextState({ ...contextState });
  }, [contextState, chatSupportService]);

  return (
    <ChatSupportContext.Provider value={{ states: contextState, actions: chatSupportService }}>
      <div className="flex h-[100vh] bg-slate-100 p-1 ">
        <div className=" min-h-full flex  flex-col  bg-white    rounded-lg drop-shadow-md border  w-[350px] ">
          <ChatNav />
        </div>
        <div className="ms-4 h-full  w-full  overflow-x-auto">{activeChatRoom && <ActiveChat />}</div>
      </div>
    </ChatSupportContext.Provider>
  );
};
